export const hkidMask = ["AX#####()", "AX#####(X)", "AX######(X)"];
export const dobMask = "####/##/##";